import React from "react";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SouthIcon from '@mui/icons-material/South';
import Slider from "@mui/material/Slider";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import {
  ContestsContainer,
  ContestContainerJ,
  ContestJ,
  LastJ,
  First,
  StatusC,
  SpotsLeft,
  SpotsRight,
  NoContests,
  JoincontestBtn,
  M,
  C,
  F
} from "./ContestStyles";
import { FURL } from "../constants/userConstants";
import styled from "@emotion/styled";

const Card = styled(Grid)`
margin-left:-16px !important;
`

export default function MyContestsTab({ contest, matchlive, navigate, setValue }) {
  return (
    <ContestsContainer container spacing={2} justifyContent="center">
      {contest.length > 0 ? (
        contest.map((tab) => {
          const spotsFilled = tab?.contest?.totalSpots - tab?.contest?.spotsLeft;
          const spotsPercent = Math.round((spotsFilled / tab?.contest?.totalSpots) * 100);
          const isAlmostFull = tab?.contest?.spotsLeft <= 5;
          return (
            <Card item md={12} lg={12} sm={12} xs={12}
              key={tab.contest._id}
              onClick={() => navigate(`/contestdetail/${tab.contest._id}`, {
                state: { match_details: matchlive },
              })}
            >
              <div
                style={{
                  border: isAlmostFull ? "2px solid #ff1744" : "1px solid #f0f0f0",
                  background: "linear-gradient(180deg, #ffffff, #fafafa)",
                  backdropFilter: "blur(10px)",
                  borderRadius: 16,
                 boxShadow: "0 6px 25px rgba(0,0,0,0.12)",
transition: "all 0.3s ease",
                  position: "relative",
                  overflow: "hidden",
                  padding: 20,
                  marginBottom: 16,
                  cursor: "pointer",
                }}
                    onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-5px) scale(1.02)";
  e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.2)";
}}

  // 👇 ये यहीं add करना है
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0px) scale(1)";
    e.currentTarget.style.boxShadow = "0 6px 25px rgba(0,0,0,0.12)";
  }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <span style={{ display: "flex", alignItems: "center", fontWeight: 700, fontSize: 20, color: "var(--red)" }}>
                    <MonetizationOnOutlinedIcon style={{ color: "var(--red)", marginRight: 4 }} />
                    ₹{tab?.contest?.price}
                  </span>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>
                    Entry&nbsp;<b>₹{tab?.contest?.entryFee}</b>
                  </span>
                </div>
                <div style={{ marginBottom: 8, display: "flex", gap: 8, alignItems: "center" }}>
                  <PeopleAltOutlinedIcon fontSize="small" />
                  <span style={{ fontWeight: 500 }}>{tab?.contest?.totalSpots} spots</span>
                  <span style={{
                    color: isAlmostFull ? "var(--red)" : "#888",
                    fontWeight: 600,
                    marginLeft: "auto"
                  }}>
                    {tab?.contest?.spotsLeft} left
                  </span>
                </div>
               <div style={{
  height: "8px",
  background: "#eee",
  borderRadius: "10px",
  margin: "10px 0"
}}>
  <div style={{
    width: `${spotsPercent}%`,
    height: "100%",
    background: "linear-gradient(90deg, #00e676, #00c853)",
boxShadow: "0 0 8px rgba(0,255,100,0.5)",
    borderRadius: "10px"
  }}></div>
</div>
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 12
                }}>
                  <span style={{ fontSize: 13, color: "#888" }}>
                    {spotsPercent}% filled
                  </span>
                  <span style={{
                    background: "linear-gradient(135deg, #e3f2fd, #bbdefb)",
                    borderRadius: 6,
                    padding: "2px 10px",
                    fontSize: 13,
                    color: "#007bff",
                    fontWeight: 600,  
                    display: "flex",
                    alignItems: "center"
                  }}>
                    <EmojiEventsOutlinedIcon fontSize="small" style={{ marginRight: 4 }} />
                    {tab.contest.prizeDetails.length} Winners
                  </span>
                </div>
                {/* Teams and status */}
                <div style={{ marginTop: 16 }}>
                 {tab.teams.map((t) => {  
                   return (
                    <div key={t.teamId} style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                       borderRadius: "8px",
                      borderBottom: "1px solid #eee",
                      transition: "0.2s"
                    }}  // 👇 यहीं लगाना है
  onMouseEnter={(e) => e.currentTarget.style.background = "#fafafa"}
  onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
                        >
                      <div style={{ flex: 2 }}>
                        <div style={{ fontWeight: 600 }}>{t?.username}</div>
                        {t.status === "Cancelled" ? (
  <div style={{ color: 'red', fontSize: 12 }}>
    ❌ Refunded
  </div>
) : matchlive?.result === 'Complete' ? (
  t.won > 0 ? (
    <div style={{ color: 'var(--green)', fontSize: 12 }}>
      🎉 You won ₹{t.won}
    </div>
  ) : (
    <div style={{ color: '#999', fontSize: 12 }}>
      No Winnings
    </div>
  )
) : (
  <div style={{ color: 'var(--green)', fontSize: 12 }}>
    IN WINNING ZONE
  </div>
)}
 
                      </div>
                      <div style={{ flex: 1, textAlign: "center" }}>T{t?.teamId}</div>
                      <div style={{ flex: 1, textAlign: "center" }}>{t?.points}</div>
                      <div style={{
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: "flex-end",
  fontWeight: "bold",
   color: t?.rank != null && t.rank <= tab?.contest?.prizeDetails?.length ? "green" : "red"
}}>
 {t.status !== "Cancelled" && t?.rank != null && `#${t.rank}`}

  {t.status !== "Cancelled" && t?.rank != null && (
  t.rank <= tab?.contest?.prizeDetails?.length ? (
      <ArrowUpwardIcon
        style={{
          color: 'var(--green)',
          fontSize: '18px',
          marginLeft: '5px',
        }}
      />
    ) : (
      <SouthIcon
        style={{
          color: 'var(--red)',
          fontSize: '18px',
          marginLeft: '5px',
        }}
      />
    )
  )}
</div>
                    </div>
                   );
                  })}
                </div>
                {/* Almost Full Badge */}
                {isAlmostFull && (
                  <div style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    background: "linear-gradient(135deg, #ff3d00, #ff1744)",
                    boxShadow: "0 0 10px rgba(255,0,0,0.5)",
                    color: "#fff",
                    padding: "4px 12px",
                    borderBottomLeftRadius: 12,
                    fontWeight: 700,
                    fontSize: 13
                  }}>
                    Almost Full!
                  </div>
                )}
              </div>
            </Card>
          );
        })
      ) : (
        <NoContests>
          <p> you have not joined a contest yet!</p>
          <img src={`${FURL}/contest.png`} alt="" />
          <p>What are you waiting for?</p>
          <JoincontestBtn onClick={() => setValue(0)}>
            join a contest
          </JoincontestBtn>
        </NoContests>
      )}
    </ContestsContainer>
  );
}
